import { ApiResponse, TokenData, DiscountDocumentType } from '../models';
import * as http from './http';
import ApiService from './service';

export class DiscountDocumentTypeService extends ApiService {
  public async loadDiscountDocumentType() {
    const url = `${this.apiDomain}/api/discount/document-type`;

    const resposne = await http.get<ApiResponse<DiscountDocumentType[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async updateDiscountDocumentType(
    data: DiscountDocumentType,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/discount/document-type/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async createDiscountDocumentType(data: DiscountDocumentType) {
    const url = `${this.apiDomain}/api/discount/document-type`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async deleteDiscountDocumentType(id?: string) {
    const url = `${this.apiDomain}/api/discount/document-type/${id}`;

    const response = await http.remove<ApiResponse<DiscountDocumentType>>(
      url,
      this.store
    );
    return response.data;
  }
}
